// extracted by mini-css-extract-plugin
export var textInput = "_iy-0";